/**
 * Performance PDP obscure one-time link:
 * — Label shows single-unit price (not subscription card qty).
 * — Click selects Skio one-time, forces quantity 1, submits via onSubmitAtcForm.
 */
(function () {
  var BUY_ONCE_QTY = 1;
  var rafId = null;

  function formatMoney(cents) {
    if (typeof window.Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function getVariantFromForm(form) {
    var idEl = form.querySelector('[name="id"]');
    if (!idEl) return null;
    var vid = parseInt(idEl.value, 10);
    if (!Number.isFinite(vid)) return null;
    try {
      var variants = JSON.parse(form.getAttribute("data-variants") || "[]");
      return variants.find(function (x) {
        return x.id === vid;
      });
    } catch (e) {
      return null;
    }
  }

  /** Always quantity 1 for buy-once (never subscription card / form sync). */
  function ensureBuyOnceQuantity(form) {
    var formQty = form.querySelector('input[name="quantity"]');
    if (!formQty) {
      formQty = document.createElement("input");
      formQty.type = "hidden";
      formQty.name = "quantity";
      formQty.setAttribute("data-obscure-buy-once-qty", "");
      form.appendChild(formQty);
    }
    formQty.value = String(BUY_ONCE_QTY);
  }

  function clearSellingPlan(form) {
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp) sp.value = "";
  }

  function hasPerformanceTiers(form) {
    var root = form.closest("#product-template");
    return !!(root && root.querySelector("[data-performance-pdp-tier]:not(.performance-pdp-tier--missing)"));
  }

  /** Performance PDP uses tier blocks instead of Skio obscure fieldset. */
  function applyPerformanceBuyOnce(form) {
    var root = form.closest("#product-template") || document;
    ensureBuyOnceQuantity(form);
    clearSellingPlan(form);
    form.classList.remove("performance-pdp-tier-qty-active");

    root.querySelectorAll("[data-performance-pdp-tier]").forEach(function (tier) {
      tier.classList.remove("performance-pdp-tier--active");
      var radio = tier.querySelector("[data-performance-pdp-tier-radio]");
      if (radio) radio.checked = false;
    });

    root.classList.add("performance-pdp--buy-once-selected");

    var discountProp = form.querySelector('[name="properties[Discount]"]');
    if (discountProp) discountProp.disabled = true;

    if (typeof window.syncPerformanceStickyAtc === "function") {
      window.syncPerformanceStickyAtc();
    }

    document.dispatchEvent(new CustomEvent("performance-pdp:buy-once-selected", { detail: { form: form } }));
  }

  function submitBuyOnceAtc(form) {
    window.setTimeout(function () {
      ensureBuyOnceQuantity(form);
      clearSellingPlan(form);
      if (typeof window.onSubmitAtcForm !== "function") return;
      window.onSubmitAtcForm(form, { preventDefault: function () {} });
    }, 50);
  }

  function updateShippingSpan(wrap, lineCents, shipEl) {
    if (!shipEl || !wrap) return;
    var staticSuf = wrap.getAttribute("data-obscure-shipping-suffix") || "";
    var freeMin = parseInt(wrap.getAttribute("data-obscure-free-shipping-min-cents") || "0", 10);
    var freeNote = wrap.getAttribute("data-obscure-free-shipping-note") || "(Free shipping)";
    if (freeMin > 0 && lineCents >= freeMin) {
      shipEl.textContent = " " + freeNote;
    } else if (staticSuf) {
      shipEl.textContent = " " + staticSuf;
    } else {
      shipEl.textContent = "";
    }
  }

  function updateObscureLink(btn) {
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    var v = getVariantFromForm(form);
    if (!v || typeof v.price !== "number") return;
    var lineCents = v.price * BUY_ONCE_QTY;
    var priceEl = btn.querySelector(".skio-performance-obscure-buy-once-price");
    if (priceEl) priceEl.textContent = formatMoney(lineCents);
    var wrap = btn.closest(".skio-performance-obscure-buy-once-wrap");
    updateShippingSpan(wrap, lineCents, btn.querySelector(".skio-performance-obscure-buy-once-shipping"));
  }

  function scheduleUpdate(root) {
    if (rafId != null) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      var scope = root || document.getElementById("product-template") || document;
      scope.querySelectorAll("[data-skio-performance-obscure-buy-once]").forEach(updateObscureLink);
    });
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-skio-performance-obscure-buy-once]");
    if (!trigger) return;
    e.preventDefault();
    var form = trigger.closest('form[action*="/cart/add"]');
    if (!form) return;
    var fieldset = form.querySelector("fieldset.skio-plan-picker--obscure-buy-once");
    var oneTime = fieldset && fieldset.querySelector("input[skio-one-time]");

    if (oneTime) {
      ensureBuyOnceQuantity(form);
      oneTime.checked = true;
      oneTime.dispatchEvent(new Event("change", { bubbles: true }));
      submitBuyOnceAtc(form);
      return;
    }

    if (hasPerformanceTiers(form)) {
      applyPerformanceBuyOnce(form);
      submitBuyOnceAtc(form);
    }
  });

  function bindObscureFieldsets() {
    document.querySelectorAll("fieldset.skio-plan-picker--obscure-buy-once").forEach(function (fs) {
      if (fs.dataset.skioObscurePickerUpdateBound) return;
      fs.dataset.skioObscurePickerUpdateBound = "1";
      fs.addEventListener("skio:plan-picker:update", function () {
        scheduleUpdate(document.getElementById("product-template"));
      });
    });
  }

  window.addEventListener("variantChange.ecomify.product", function () {
    scheduleUpdate(document.getElementById("product-template"));
  });

  document.addEventListener("product:flavor-section-swapped", function (ev) {
    var sectionRoot = ev.detail && ev.detail.root;
    if (!sectionRoot) return;
    bindObscureFieldsets();
    var pt = sectionRoot.querySelector("#product-template");
    scheduleUpdate(pt || sectionRoot);
  });

  document.addEventListener("DOMContentLoaded", function () {
    bindObscureFieldsets();
    var root = document.getElementById("product-template");
    scheduleUpdate(root);
    window.setTimeout(function () {
      bindObscureFieldsets();
      scheduleUpdate(root);
    }, 120);
  });

  document.addEventListener("skio:plan-picker:loaded", function () {
    bindObscureFieldsets();
    scheduleUpdate(document.getElementById("product-template"));
  });
})();
